<!-- src/apps/secret/components/conceal/landing/ProtocolSection.vue -->

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import LandingSectionHeader from './LandingSectionHeader.vue';

  const { t } = useI18n();

  // Function-styled step labels are part of the visual identity (not
  // translated); descriptions are honest about the server-side flow.
  const steps = [
    { fn: 'encrypt()', descKey: 'landing.protocol.step_encrypt' },
    { fn: 'store(ttl)', descKey: 'landing.protocol.step_store' },
    { fn: 'share(url)', descKey: 'landing.protocol.step_share' },
    { fn: 'read → delete()', descKey: 'landing.protocol.step_read' },
  ];
</script>

<template>
  <section class="border-b border-day-line dark:border-white/[0.07]">
    <LandingSectionHeader
      number="02."
      :title="t('landing.protocol.title')" />
    <div class="grid grid-cols-1 md:grid-cols-4">
      <div
        v-for="(step, i) in steps"
        :key="step.fn"
        class="p-6 sm:p-9 md:px-9 md:py-12"
        :class="[
          i < steps.length - 1
            ? 'border-b border-day-line md:border-r md:border-b-0 dark:border-white/[0.07]'
            : '',
        ]">
        <div class="mb-4 flex items-center gap-2.5">
          <span
            class="inline-block size-1.5 shrink-0 rounded-full bg-brand-500 shadow-[0_0_8px_var(--color-brand-500)]"
            aria-hidden="true"></span>
          <span class="font-mono text-sm font-semibold tracking-[-0.01em] text-brand-600 dark:text-brand-400">{{ step.fn }}</span>
        </div>
        <p class="text-[15px] leading-[1.65] text-day-ink-muted dark:text-night-ink-muted">
          {{ t(step.descKey) }}
        </p>
      </div>
    </div>
  </section>
</template>
